<div
  class="flex flex-col items-center justify-center text-center w-full"
  [class.py-6]="compact"
  [class.px-4]="compact"
  [class.py-12]="!compact"
  [class.px-6]="!compact"
>
  <!-- Icon Bubble -->
  <div
    class="rounded-2xl bg-amber-50/80 border border-amber-200/60 flex items-center justify-center text-primary mb-3 shadow-xs"
    [class.w-11]="compact"
    [class.h-11]="compact"
    [class.w-14]="!compact"
    [class.h-14]="!compact"
  >
    @switch (icon) {
      @case ('search') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.75"
          stroke="currentColor"
          [class.w-5]="compact"
          [class.h-5]="compact"
          [class.w-7]="!compact"
          [class.h-7]="!compact"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
          />
        </svg>
      }
      @case ('folder') {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.75"
          stroke="currentColor"
          [class.w-5]="compact"
          [class.h-5]="compact"
          [class.w-7]="!compact"
          [class.h-7]="!compact"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
          />
        </svg>
      }
      @default {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.75"
          stroke="currentColor"
          [class.w-5]="compact"
          [class.h-5]="compact"
          [class.w-7]="!compact"
          [class.h-7]="!compact"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M20.25 7.5l-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
          />
        </svg>
      }
    }
  </div>

  <!-- Title -->
  @if (title) {
    <p class="text-sm md:text-base font-semibold text-gray-800 m-0">
      {{ title | translate }}
    </p>
  }

  <!-- Description -->
  @if (description) {
    <p class="text-xs md:text-sm text-gray-500 max-w-sm mt-1.5 m-0">
      {{ description | translate }}
    </p>
  }

  <!-- Slot for custom markup -->
  <ng-content></ng-content>

  <!-- Action Button / Link -->
  @if (actionLabel) {
    @if (actionRouterLink) {
      <a
        [routerLink]="actionRouterLink"
        class="empty-state-btn inline-flex items-center justify-center gap-2 px-5 py-2 mt-4 text-sm font-medium !text-white rounded-xl shadow-sm hover:opacity-90 active:scale-[0.98] transition-all cursor-pointer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 !text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
        </svg>
        <span class="!text-white">{{ actionLabel | translate }}</span>
      </a>
    } @else {
      <button
        type="button"
        (click)="onAction()"
        class="empty-state-btn inline-flex items-center justify-center gap-2 px-5 py-2 mt-4 text-sm font-medium !text-white rounded-xl shadow-sm hover:opacity-90 active:scale-[0.98] transition-all cursor-pointer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 !text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"/>
        </svg>
        <span class="!text-white">{{ actionLabel | translate }}</span>
      </button>
    }
  }
</div>
